import React from "react";
import { Link } from "react-router-dom";

export default function GoogleAuthFail() {
  return (
    <div>
      GoogleAuthFail Page
      <br />
      <Link to="/">Homepage</Link>
    </div>
  );
}
